import React, { useEffect } from 'react'
import { Box } from './ui/Elements';
import { Route, Routes, useLocation } from 'react-router-dom';
import { privateRoute } from './routes/PrivateRoute';
import { useCookies } from 'react-cookie';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import i18n from './Languages/INEXT';
import { useTranslation } from 'react-i18next';
import { trackSnapCallClick } from './services/snapPixel';
function App() {
	const location = useLocation();
	const {
		i18n: { language },
	} = useTranslation();
	useEffect(() => {
		window.scroll({ top: 0, behaviour: 'smooth' })
	}, [location]);
	useEffect(() => {
		// نقرات الاتصال الهاتفي في أي مكان بالموقع → حدث سناب CUSTOM_EVENT_2
		const onTelClick = (e) => {
			const tel = e.target.closest && e.target.closest('a[href^="tel:"]');
			if (tel) trackSnapCallClick('site');
		};
		document.addEventListener('click', onTelClick);
		return () => document.removeEventListener('click', onTelClick);
	}, []);
	const [cookies, setCookie] = useCookies(['lang']);
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		setCookie('lang', lng, { path: '/' });
	};
	return (
		<>
			<ToastContainer
				position={language === "ar" ? "top-left" : "top-right"}
				rtl={language === "ar"}
			/>
			<Box>
				<Routes>
					{privateRoute.map((list, key) => (
						<Route to={key} {...list} />
					))}
				</Routes>
			</Box>
		</>
	);
}
export default App;
